import { Routes } from '@angular/router';
import { SAM_ROUTES } from '@aubert-et-duval/samv2';
import { HomeComponent } from './geoxp/home/home.component';

export const routes: Routes = [
    { path: 'home', component: HomeComponent },
    {
        path: 'search',
        loadChildren: () => import('./modules/search/search-desktop.module').then(m => m.SearchDesktopModule),
    },
    {
        path: 'inventory',
        loadChildren: () => import('./modules/inventory/inventory-desktop.module').then(m => m.InventoryDesktopModule),
    },
    {
        path: 'areas',
        loadChildren: () => import('./modules/areas/areas.module').then(m => m.AreasDesktopModule),
    },
    {
        path: 'expeditions/dpe',
        loadComponent: () => import('./geoxp/expeditions/dpe/expeditions.component').then(m => m.ExpeditionsComponent),
    },
    {
        path: 'expeditions/dpe/treatment',
        loadComponent: () => import('./geoxp/expeditions/dpe-treatment/pages/home/dpe-treatment-home.component').then(m => m.DpeTreatmentHomeComponent),
    },
    {
        path: 'expeditions/pairing-parcel',
        loadComponent: () => import('./geoxp/expeditions/pairing-parcel/pairing-parcel.component').then(m => m.EditPairingParcelComponent),
    },
    {
        path: 'expeditions/chargement',
        loadComponent: () => import('./geoxp/expeditions/chargement/chargement.component').then(m => m.EditChargementComponent),
    },
    {
        path: 'expeditions/printing-parcel-label',
        loadComponent: () => import('./geoxp/expeditions/printing-parcel-label/printing-parcel-label.component').then(m => m.PrintingParcelLabelComponent),
    },
    {
        path: 'expeditions/unpairing-parcel',
        loadComponent: () => import('./geoxp/expeditions/unpairing-parcel/unpairing-parcel.component').then(m => m.UnpairingParcelComponent),
    },
    {
        path: 'parts-to-move',
        loadComponent: () => import('./geoxp/parts-to-move/parts-to-move.component').then(m => m.PartsToMoveComponent),
    },
    {
        path: 'pairing-pieces',
        loadComponent: () => import('./geoxp/pairing/pairing-pieces.component').then(m => m.PairingPiecesComponent),
    },
    {
        path: 'unpairing-pieces',
        loadComponent: () => import('./geoxp/unpairing/unpairing-pieces.component').then(m => m.UnpairingPiecesComponent),
    },
    {
        path: 'move-pairing',
        loadComponent: () => import('./geoxp/move-pairing/move-pairing.component').then(m => m.MovePairingComponent),
    },
    {
        path: 'tags-paired',
        loadComponent: () => import('./geoxp/pairing/tags-paired/tags-paired.component').then(m => m.TagsPairedComponent),
    },
    {
        path: 'demandes-approvisionnement-tags',
        loadComponent: () => import('./geoxp/pairing/appro-tags/appro-tags.component').then(m => m.ApproTagsComponent),
    },
    {
        path: 'settings/articles',
        loadComponent: () => import('./geoxp/settings/articles/articles.component').then(m => m.ArticlesComponent),
    },
    {
        path: 'settings/article-edit',
        loadComponent: () => import('./geoxp/settings/articles/article-edit/article-edit.component').then(m => m.EditArticleComponent),
    },
    {
        path: 'settings/comments',
        loadComponent: () => import('./geoxp/settings/comments/comments.component').then(m => m.CommentsComponent),
    },
    {
        path: 'settings/comment-edit',
        loadComponent: () => import('./geoxp/settings/comments/comment-edit/comment-edit.component').then(m => m.EditCommentComponent),
    },
    {
        path: 'settings/exp/interrupt-reasons',
        loadComponent: () => import('./geoxp/settings/expedition/interrupt-reasons/interrupt-reasons.component').then(m => m.InterruptReasonsComponent),
    },
    {
        path: 'settings/exp/interrupt-reasons/edit',
        loadComponent: () => import('./geoxp/settings/expedition/interrupt-reasons/interrupt-reason-edit/interrupt-reason-edit.component').then(m => m.EditInterruptReasonComponent),
    },
    {
        path: 'settings/exp/priorities',
        loadComponent: () => import('./geoxp/settings/expedition/priorities/priorities.component').then(m => m.PrioritiesComponent),
    },
    {
        path: 'settings/exp/priorities/edit',
        loadComponent: () => import('./geoxp/settings/expedition/priorities/priority-edit/priority-edit.component').then(m => m.EditPriorityComponent),
    },
    {
        path: 'mahvis',
        loadChildren: () => import('./modules/touareg-control/touareg-control.module').then(m => m.TouaregControlDesktopModule),
    },
    { path: '', redirectTo: '/home', pathMatch: 'full' },
    // Les routes locales doivent précéder les routes SAM pour éviter qu'elles soient masquées.
    // Les éventuels overrides de routes SAM doivent aussi rester avant ...SAM_ROUTES.
    ...SAM_ROUTES,
    { path: '**', redirectTo: '' }
];
